<script>
import VueKonva from "vue-konva";

let cachedComponents = null;

export function getKonvaComponents() {
  if (cachedComponents) {
    return cachedComponents;
  }

  const components = {};
  VueKonva.install({
    component(key, component) {
      components[key] = component;
    },
  });

  cachedComponents = components;
  return components;
}
</script>
